import { render, staticRenderFns } from "./notification-factory.vue?vue&type=template&id=3f5b7c03"
import script from "./notification-factory.vue?vue&type=script&lang=js"
export * from "./notification-factory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports